/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DocumentType {
  WorkDocument = 0,
  CaseDocument = 1,
  MessageDocument = 2,
  Eur1 = 3,
  RegistrationCard = 4,
  Delivery = 5,
  T2L = 6,
  OtherInvoicing = 7,
  AdditionalHandling = 8,
}
